export default __webpack_public_path__ + "static/media/chester-wade.e891184f.jpg";